import { render, staticRenderFns } from "./AutoLink.vue?vue&type=template&id=92fc9186&scoped=true&"
import script from "./AutoLink.vue?vue&type=script&lang=ts&"
export * from "./AutoLink.vue?vue&type=script&lang=ts&"
import style0 from "./AutoLink.vue?vue&type=style&index=0&id=92fc9186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92fc9186",
  null
  
)

export default component.exports